
import React, { useState, useEffect } from 'react';
import { MapPin } from 'lucide-react';
import { formatDistanceToNow } from 'date-fns';
import { ru } from 'date-fns/locale';

interface BikeLastUpdateProps {
  lastServiceDate?: string;
}

export const BikeLastUpdate: React.FC<BikeLastUpdateProps> = ({ lastServiceDate }) => {
  const [lastService, setLastService] = useState<string>('');
  
  useEffect(() => {
    if (lastServiceDate) {
      const updateTime = () => {
        try {
          const serviceDate = new Date(lastServiceDate);
          setLastService(
            formatDistanceToNow(serviceDate, { addSuffix: true, locale: ru })
          );
        } catch (error) {
          console.error('Ошибка при форматировании времени последнего ТО:', error);
          setLastService('неизвестно');
        }
      };
      
      updateTime();
      const interval = setInterval(updateTime, 60000);
      
      return () => clearInterval(interval);
    } else {
      setLastService('не указано');
    }
  }, [lastServiceDate]);

  return (
    <div className="flex items-center gap-2 mt-2">
      <MapPin className="h-5 w-5 text-blue-500" />
      <div>
        <p className="text-sm text-muted-foreground">Последнее ТО</p>
        <p className="font-medium">{lastService}</p>
      </div>
    </div>
  );
};
